import styled from "@emotion/styled";
import {
  Alert,
  alertClasses,
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from "@mui/material";

export const BodyLarge = styled(Typography)({
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '24px'
});

export const FlexColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const FlexRow = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
});

export const FlexRowWithFlexWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  }
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(3),
  background: theme.palette.common.white,
  boxShadow: 'none',
  border: `${theme.spacing(0.125)} solid rgba(0, 0, 0, 0.15)`,
}));

export const Tile = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(0),
  alignItems: 'center',
  gap: theme.spacing(2),
  ':last-child': { paddingBottom: 0  },
}));

export const IconWrapper = styled(FlexColumn)(({ theme }) => ({
  height: theme.spacing(8.5),
  width: theme.spacing(4.25),
  padding: theme.spacing(1),
  border: `${theme.spacing(0.5)} solid ${theme.palette.common.black}`,
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const RemoveButton = styled(Button)(({ theme }) => ({
  textDecoration: 'underline',
  marginTop: theme.spacing(1),
  ml: theme.spacing(-0.5),
  lineHeight: '16px',
  textUnderlineOffset: '2px',
  padding: 0,
}));

export const StyledAlert = styled(Alert)(({ theme }) => ({
  display: 'flex',
  paddingRight: '2px',
  alignItems: 'center',
  borderRadius: '12px',
  border: '1px solid rgba(0, 0, 0, 0.15)',
  background: '#FFF',
  borderLeft: '6px solid #D7004B',
  [`&.${alertClasses.root}`]: {
    padding: theme.spacing(2, 3),
    alignItems: 'center',
  },
  [`.${alertClasses.icon}`]: {
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
    padding: 0,
  },
  [`.${alertClasses.message}`]: {
    padding: theme.spacing(0),
  },
  [`.${alertClasses.action}`]: {
    padding: theme.spacing(2),
  },
}));

export const PrimaryActionButton = styled(Button)({
  color: '#000',
  border: '1px solid #000',
  '&:hover': {
    color: '#000',
    border: '1px solid #000',
    backgroundColor: 'transparent',
  },
  '&:disabled': {
    background: 'transparent',
    cursor: 'not-allowed',
  },
});

export const SecondaryActionButton = styled(Button)({
  color: '#000',
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
  '&:hover': {
    color: '#000',
    textDecoration: 'none',
    backgroundColor: 'transparent',
  },
  '&:disabled': {
    background: 'transparent',
    cursor: 'not-allowed',
  },
});

export const ModalContentWrapper = styled(Box)(({ theme, type }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  background: theme.palette.common.white,
  borderRadius: '12px',
  overflow: 'hidden',
  borderTop: type === 'warning' ? '6px solid #FA6323' : 'none',
  ...(type !== 'warning' && {
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '6px',
      background: `linear-gradient(
        90deg,
        #0046FE 0%,
        #6F10F4 31.25%,
        #EB3776 67.71%,
        #FF6436 100%
      )`,
    },
  }),

  boxShadow: `0 16px 24px 0 rgba(0, 0, 0, 0.14),
    0 6px 30px 0 rgba(0, 0, 0, 0.12),
    0 8px 10px 0 rgba(0, 0, 0, 0.20)`,

  [theme.breakpoints.down('sm')]: {
    width: 'calc(100% - 40px)',
  },
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(5, 2),
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  'label': {
    display: 'none',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    background: theme.palette.common.white,
    'input': {
      padding: theme.spacing(1, 2),
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E2129',
      borderWidth: '1px',
      '& legend': {
        display: 'none',
      }
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #1E2129',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #1E2129',
    }
  },
}));
